import { render, staticRenderFns } from "./Qcq.vue?vue&type=template&id=4b834ec4&scoped=true&lang=pug&"
import script from "./Qcq.vue?vue&type=script&lang=ts&"
export * from "./Qcq.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b834ec4",
  null
  
)

export default component.exports